import Vue from "vue";
import { Component } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch("market/loadProcessOrder");
    });
  }
})
class ProcessOrders extends Vue {
  @State(state => state.market.hasProcessOrder) hasProcessOrder;

  timer: any = null;

  mounted() {
    this.$store.commit("market/SET_SHOW_PROCESS_ORDER_BTN", true);
  }

  beforeDestroy() {
    this.$store.commit("market/SET_SHOW_PROCESS_ORDER_BTN", false);
  }
}

export default ProcessOrders;
